"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var Collections = __importStar(require("typescript-collections"));
var UserSearchSelector_1 = __importDefault(require("./UserSearchSelector/UserSearchSelector"));
var UsersController = require("../Users/Users");
var PendingInvitesController = require("../Invites/PendingInvites");
var PendingInviteRequestsController = require("../InviteRequests/PendingInviteRequests");
var actionsDropdown = require("../MoreActionsDropdown/Dropdown");
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
exports.default = (function (createUi, InviteUser, userList, make, invoke, showDeleteModal, account, $timeout, $tooltip, utils, rolesService, user, usingFeature, telemetry) {
    return (function () {
        function AccountTeamController(teamId, teamName, teamType, teamMembers, teamsService, teamManager, pendingInvitations, pendingRequests) {
            var _this = this;
            this.teamId = teamId;
            this.teamName = teamName;
            this.teamType = teamType;
            this.teamMembers = teamMembers;
            this.teamsService = teamsService;
            this.teamManager = teamManager;
            this.pendingInvitations = pendingInvitations;
            this.pendingRequests = pendingRequests;
            this.domId = "team-".concat(utils.uniqueId(8));
            this.tooltipElementSelector = "#".concat(this.domId, ".account-team-container .pencil-icon");
            this.tooltipContainerSelector = "#".concat(this.domId, ".account-team-container");
            this.selectedUsers = new Collections.Set();
            var onUserSelect = function (selectedUser) {
                _this.addUsersToTeam([selectedUser._id]);
                _this.persist();
                _this.refreshUi();
                var role = "creator";
                if (selectedUser.roles && selectedUser.roles[0] && selectedUser.roles[0].name) {
                    role = selectedUser.roles[0].name;
                }
                var teamCount = _this.teamManager.getUsersTeams(selectedUser._id).length;
                telemetry.trackOnly("Teams Updated", {
                    user_teams_membership_origin: "search existing",
                    user_teams_membership_type: role,
                    user_teams_membership_number: teamCount,
                }, { blockIntercom: true });
            };
            this.userSearchSelector = make(UserSearchSelector_1.default, {
                allAccountUsers: userList,
                teamMembers: this.teamMembers,
                getTeam: function () {
                    return _this.teamId;
                },
                getDomId: function () {
                    return _this.ui.domId;
                },
                onSelect: onUserSelect,
                onInvited: function () {
                    return _this.refreshUi();
                },
            });
            var makeTeamDropdown = function (ui) {
                var item = {
                    name: "Remove team",
                    onClick: function ($event) {
                        confirmDeleteTeam().then(function () {
                            ui.teamDropdown.hide();
                            $event.stopPropagation();
                        });
                    },
                };
                return invoke(actionsDropdown, null, {
                    items: [item],
                    selector: ".team-dropdown-actions",
                });
            };
            var confirmDeleteTeam = function () {
                return showDeleteModal({
                    title: "Remove team?",
                    explainer: "Removing a team will also remove any consequent team permissions for the team members",
                    deleteButton: "Remove team",
                }).then(function (confirmed) {
                    if (confirmed) {
                        return _this.deleteTeam();
                    }
                });
            };
            var canInviteUsers = function () {
                if (!account.settings.permissions.userInvitePermission) {
                    return rolesService.isAdmin(user);
                }
                if (account.settings.permissions.userInvitePermission == "creator" ||
                    account.settings.permissions.userInvitePermission == "domain") {
                    return true;
                }
                else {
                    return rolesService.isAdmin(user);
                }
            };
            this._ui = createUi(require("./AccountTeam.html"), {
                teamName: this.teamName,
                canEditTeam: rolesService.isAdmin(user),
                canInviteUsers: canInviteUsers(),
                domId: this.domId,
                isUsingTeams: function () {
                    return usingFeature(FeatureFlag_1.FeatureFlag.Teams);
                },
                isUsingCollaboratorComment: function () {
                    return usingFeature(FeatureFlag_1.FeatureFlag.CollaboratorComment);
                },
                toggleShowTeamMembers: function () {
                    _this.ui.showTeamMembers = !_this.ui.showTeamMembers;
                },
                showTeamMembers: true,
                userSearchSelectorView: this.userSearchSelector.ui,
                teamDropdown: makeTeamDropdown(this.ui),
                showDropdown: function () {
                    if (_this.ui.teamDropdown && _this.ui.teamDropdown.ui.visible) {
                        _this.ui.teamDropdown.hide();
                    }
                    else {
                        _this.ui.teamDropdown = makeTeamDropdown(_this.ui);
                        _this.ui.teamDropdown.show();
                    }
                },
                persist: function () {
                    _this.persist();
                },
                isAccountWideTeam: function () {
                    return _this.isAccountWideTeam();
                },
                userInvite: null,
                emptySeats: null,
                $onElementRendered: function (elem) {
                    $timeout(function () {
                        var inputBox = elem.find("input.editable-title");
                        if (!_this.ui.teamName) {
                            inputBox.trigger("focus");
                        }
                    }, 250);
                },
            });
            this.refreshUi();
        }
        AccountTeamController.prototype.addUsersToTeam = function (userIds) {
            var usersToAdd = lodash_1.default.filter(userList, function (userA) {
                return lodash_1.default.includes(userIds, userA._id);
            });
            if (usersToAdd && usersToAdd.length > 0) {
                this.teamMembers = lodash_1.default.union(this.teamMembers, usersToAdd);
            }
        };
        AccountTeamController.prototype.deleteTeam = function () {
            this.teamManager.deleteTeam(this);
        };
        AccountTeamController.prototype.removeUsersFromTeam = function (userIds) {
            var usersToRemove = lodash_1.default.filter(userList, function (userA) {
                return lodash_1.default.includes(userIds, userA._id);
            });
            if (usersToRemove && usersToRemove.length > 0) {
                this.teamMembers = lodash_1.default.pullAll(this.teamMembers, usersToRemove);
            }
        };
        AccountTeamController.prototype.getMembers = function () {
            return this.teamMembers;
        };
        Object.defineProperty(AccountTeamController.prototype, "ui", {
            get: function () {
                return this._ui;
            },
            enumerable: false,
            configurable: true
        });
        AccountTeamController.prototype.getTeamPendingInvitations = function () {
            var _this = this;
            if (this.pendingInvitations) {
                return this.pendingInvitations;
            }
            var pendingInvitations = account.pendingInvitations;
            var invitationIds = [];
            lodash_1.default.map(pendingInvitations, function (invitation) {
                var invitationTeamIds = invitation.teams;
                if (lodash_1.default.includes(invitationTeamIds, _this.teamId)) {
                    invitationIds.push(invitation._id);
                }
            });
            var pendingInvitees = lodash_1.default.filter(account.pendingInvitations, function (invite) {
                if (_this.teamId) {
                    return lodash_1.default.includes(invitationIds, invite._id);
                }
                return false;
            });
            return pendingInvitees;
        };
        AccountTeamController.prototype.getTeamPendingRequests = function () {
            return account.pendingRequests.map(function (pendingRequest) { return ({
                _id: pendingRequest._id,
                name: pendingRequest.name,
                email: pendingRequest.email,
                permission: pendingRequest.permission,
                createdAt: pendingRequest.createdAt,
            }); });
        };
        AccountTeamController.prototype.addSelectedUser = function (userId, isSelected) {
            if (!isSelected) {
                this.selectedUsers.remove(userId);
            }
            else {
                this.selectedUsers.add(userId);
            }
            this.teamManager.postUserAdded();
        };
        AccountTeamController.prototype.refreshUi = function () {
            var _this = this;
            var usersController = make(UsersController, {
                refreshUi: function () {
                    return _this.refreshUi();
                },
                userList: this.teamMembers,
                userSelected: function (userId, isSelected) {
                    _this.addSelectedUser(userId, isSelected);
                },
            });
            this.refreshPendingInvitees();
            this.refreshPendingInviteRequestees();
            var pendingInvitesController = make(PendingInvitesController, {
                refreshUi: function () {
                    return _this.refreshUi();
                },
                pendingInvitees: this.getTeamPendingInvitations(),
            });
            var pendingInviteRequestsController = make(PendingInviteRequestsController, {
                refreshUi: function () {
                    return _this.refreshUi();
                },
                pendingInviteRequestees: this.getTeamPendingRequests(),
            });
            var _a = this.refreshEmptySeats(), emptySeats = _a.emptySeats, userInvite = _a.userInvite;
            lodash_1.default.assign(this.ui, {
                teamMemberViews: usersController.getUserUis(),
                pendingInvitesViews: pendingInvitesController.getPendingUis(),
                inviteRequests: pendingInviteRequestsController.getPendingUis(),
                emptySeats: emptySeats,
                userInvite: userInvite,
            });
        };
        AccountTeamController.prototype.getSelectedUsers = function () {
            return this.selectedUsers;
        };
        AccountTeamController.prototype.deselectUsers = function () {
            this.selectedUsers.clear();
            lodash_1.default.map(this.ui.teamMemberViews, function (view) {
                view.$selected = false;
            });
            this.teamManager.postUserAdded();
        };
        AccountTeamController.prototype.getMemberIds = function () {
            return lodash_1.default.map(this.teamMembers, function (m) {
                return m._id;
            });
        };
        AccountTeamController.prototype.isAccountWideTeam = function () {
            return this.teamType == "account";
        };
        AccountTeamController.prototype.persist = function () {
            return __awaiter(this, void 0, void 0, function () {
                var persistedTeam;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.ui.teamName) {
                                return [2, this.showTooltip("Please set a name for the team")];
                            }
                            if (!this.teamId) return [3, 2];
                            return [4, this.teamsService.updateTeam(this.teamId, this.ui.teamName, this.getMemberIds())];
                        case 1:
                            persistedTeam = _a.sent();
                            return [3, 4];
                        case 2: return [4, this.teamsService.createTeam(this.ui.teamName)];
                        case 3:
                            persistedTeam = _a.sent();
                            _a.label = 4;
                        case 4:
                            this.teamId = persistedTeam._id;
                            this.teamName = persistedTeam.name;
                            return [2, persistedTeam];
                    }
                });
            });
        };
        AccountTeamController.prototype.refreshEmptySeats = function () {
            var _this = this;
            var uiFields = {
                emptySeats: [],
                userInvite: null,
            };
            if (this.isAccountWideTeam()) {
                var emptySeatUi = make(InviteUser, {
                    options: {
                        invitesSentCallback: function () {
                            $timeout(function () {
                                return _this.refreshUi();
                            }, 2200);
                        },
                    },
                    getTeam: function () {
                        return _this.teamId ? _this.teamId : undefined;
                    },
                }).ui;
                emptySeatUi.$isEmptySeat = true;
                uiFields.userInvite = emptySeatUi;
            }
            return uiFields;
        };
        AccountTeamController.prototype.showTooltip = function (message) {
            var _this = this;
            this.tooltip = $tooltip($(this.tooltipElementSelector), {
                title: message,
                trigger: "manual",
                container: $(this.tooltipContainerSelector),
                placement: "right",
            });
            this.tooltip.$promise.then(function () {
                _this.tooltip.show();
            });
            $timeout(function () {
                _this.tooltip.hide();
            }, 2000);
        };
        AccountTeamController.prototype.refreshPendingInvitees = function () {
            if (this.isAccountWideTeam()) {
                this.pendingInvitations = account.pendingInvitations;
            }
        };
        AccountTeamController.prototype.refreshPendingInviteRequestees = function () {
            if (this.isAccountWideTeam()) {
                this.pendingRequests = account.pendingRequests;
            }
        };
        return AccountTeamController;
    }());
});
